import API from '@/api/logisticsCenter/transportOrder';

// 生成运输单逻辑
export default function (data, shop, userInfo, transport) {
  shop = shop.map((item) => {
    return Object.assign(
      {},
      {
        deliveryQuantity: item.ladingQuantity,
        productNo: item.productNo,
        contractUnit: item.ladingUnit,
        productName: item.productDesc,
        salesLadingNo: data.ladingNo,
        providerNo: data.supplierNo,
        providerName: data.supplierName,
        mark: data.mark,
      }
    );
  });
  transport = transport.map((item) => {
    return Object.assign(
      {},
      {
        nameVoyageLicense: item.nameVoyageLicense,
        freightInformation: item.mark,
        contactPerson: item.driverName,
        contactPhoneNo: item.contactPhoneNo,
        identityCardNumber: item.identityCardNo,
      }
    );
  });
  const params = {
    deliveryStatus: '1', // 新增
    tenantCode: userInfo.tenantCode,
    companyCode: userInfo.companyCode,
    companyName: userInfo.companyName,
    departmentCode: userInfo.departmentCode,
    departmentName: userInfo.departmentName,
    deliveryCreatePersonNo: userInfo.userCode,
    deliveryCreatePersonName: userInfo.userName,
    salesLadingNo: data.ladingNo,
    providerNo: data.supplierNo,
    providerName: data.supplierName,
    salesmanNo: data.ladingSalesmanNo,
    salesmanName: data.ladingSalesmanName,
    pickupStorageNo: data.storageNo,
    pickupStorageName: data.storageName,
    shiptoStorageAddress: data.deliveryAddress,
    shiptoContactPerson: data.receiver,
    shiptoContactTelephone: data.receiverPhone,
    deliveryProductName: data.productDesc,
    deliveryQuantity: data.ladingTotalQuantity,
    deliveryDetailStr: JSON.stringify(shop),
    deliveryTransportList: transport,
    deliveryTransportStr: JSON.stringify(transport),
  };
  return new Promise((resolve, reject) => {
    window.vm.$axios
      .post(API.SAVE_DELIVERY, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
